export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 10_08.42a8c764.jpg";